import { UnionMap, UnionValueMap } from '../types/union-map';
import { isString } from '../utilities/string';

export type RemoteFlagName = 'ExampleFlag'; // This is an example flag, not being used today. Future flags can be added here

export const RemoteFlagName: UnionMap<RemoteFlagName> = {
    ExampleFlag: 'ExampleFlag', // This is an example flag, not being used today. Future flags can be added here
};

export type FeatureFlagName =
    | 'EnableBetaDataPlane'
    | 'UnderDevelopment'
    | 'UseNonPreauthorizedScopes'
    | 'LogVerbose'
    | 'EnableThemeModeToggle'
    | 'SingleDevCenterMode'
    | 'DisplayNames'
    | 'RoundTripTime'
    | 'EnableDiscoveryService'
    | 'EnableIntrinsicTasksForCustomization'
    | 'EnableGuestUser'
    | 'EnableConnectWithVSCode'
    | 'EnableProgressiveHomeLoading';

export const FeatureFlagName: UnionMap<FeatureFlagName> = {
    EnableBetaDataPlane: 'EnableBetaDataPlane',
    UnderDevelopment: 'UnderDevelopment',
    UseNonPreauthorizedScopes: 'UseNonPreauthorizedScopes',
    LogVerbose: 'LogVerbose',
    EnableThemeModeToggle: 'EnableThemeModeToggle',
    SingleDevCenterMode: 'SingleDevCenterMode',
    DisplayNames: 'DisplayNames',
    RoundTripTime: 'RoundTripTime',
    EnableDiscoveryService: 'EnableDiscoveryService',
    EnableIntrinsicTasksForCustomization: 'EnableIntrinsicTasksForCustomization',
    EnableGuestUser: 'EnableGuestUser',
    EnableConnectWithVSCode: 'EnableConnectWithVSCode',
    EnableProgressiveHomeLoading: 'EnableProgressiveHomeLoading',
};

export type FeatureFlag = Lowercase<FeatureFlagName>;

export const FeatureFlag: UnionValueMap<FeatureFlagName, FeatureFlag> = {
    EnableBetaDataPlane: 'enablebetadataplane',
    UnderDevelopment: 'underdevelopment',
    UseNonPreauthorizedScopes: 'usenonpreauthorizedscopes',
    LogVerbose: 'logverbose',
    EnableThemeModeToggle: 'enablethememodetoggle',
    SingleDevCenterMode: 'singledevcentermode',
    DisplayNames: 'displaynames',
    RoundTripTime: 'roundtriptime',
    EnableDiscoveryService: 'enablediscoveryservice',
    EnableIntrinsicTasksForCustomization: 'enableintrinsictasksforcustomization',
    EnableGuestUser: 'enableguestuser',
    EnableConnectWithVSCode: 'enableconnectwithvscode',
    EnableProgressiveHomeLoading: 'enableprogressivehomeloading',
};

export const NameForFeatureFlag: UnionValueMap<FeatureFlag, FeatureFlagName> = {
    enablebetadataplane: 'EnableBetaDataPlane',
    underdevelopment: 'UnderDevelopment',
    usenonpreauthorizedscopes: 'UseNonPreauthorizedScopes',
    logverbose: 'LogVerbose',
    enablethememodetoggle: 'EnableThemeModeToggle',
    singledevcentermode: 'SingleDevCenterMode',
    displaynames: 'DisplayNames',
    roundtriptime: 'RoundTripTime',
    enablediscoveryservice: 'EnableDiscoveryService',
    enableintrinsictasksforcustomization: 'EnableIntrinsicTasksForCustomization',
    enableguestuser: 'EnableGuestUser',
    enableconnectwithvscode: 'EnableConnectWithVSCode',
    enableprogressivehomeloading: 'EnableProgressiveHomeLoading',
};

export const isFeatureFlag = (value: unknown): value is FeatureFlag => {
    if (!isString(value)) {
        return false;
    }

    switch (value.toLowerCase()) {
        case FeatureFlag.EnableBetaDataPlane:
        case FeatureFlag.UnderDevelopment:
        case FeatureFlag.UseNonPreauthorizedScopes:
        case FeatureFlag.LogVerbose:
        case FeatureFlag.EnableThemeModeToggle:
        case FeatureFlag.SingleDevCenterMode:
        case FeatureFlag.DisplayNames:
        case FeatureFlag.RoundTripTime:
        case FeatureFlag.EnableDiscoveryService:
        case FeatureFlag.EnableIntrinsicTasksForCustomization:
        case FeatureFlag.EnableGuestUser:
        case FeatureFlag.EnableConnectWithVSCode:
        case FeatureFlag.EnableProgressiveHomeLoading:
            return true;
        default:
            return false;
    }
};
